module.exports = __webpack_public_path__ + "img/idle-dj-details2.33cde2d5.png";